import React from 'react';
import PropTypes from 'prop-types';

function PinnedMessagesPopover({ pinned, loading, canUnpin, onClose, onUnpin }) {
  return (
    <aside className="community-pins" role="complementary" aria-label="Pinned messages">
      <header className="community-pins__header">
        <span className="community-pins__icon" aria-hidden="true">
          <PinIcon />
        </span>
        <h2 className="community-pins__title">Pinned Messages</h2>
        <button
          type="button"
          className="community-pins__close"
          onClick={onClose}
          aria-label="Close pinned messages"
        >
          ×
        </button>
      </header>

      {loading ? (
        <div className="community-pins__loading">Loading…</div>
      ) : pinned.length === 0 ? (
        <div className="community-pins__empty">Nothing pinned yet.</div>
      ) : (
        <ul className="community-pins__list">
          {pinned.map((pin) => {
            const displayName = pin.senderDisplayName || 'unknown';
            return (
              <li key={pin.id} className="community-pins__item">
                <div className="community-pins__avatar-col">
                  <span className="community-pins__avatar community-pins__avatar--fallback">
                    {(displayName || '?').charAt(0).toUpperCase()}
                  </span>
                </div>
                <div className="community-pins__body">
                  <div className="community-pins__meta">
                    <span className="community-pins__name">{displayName}</span>
                    <span className="community-pins__time">{formatTimestamp(pin.pinnedAt)}</span>
                  </div>
                  <div className="community-pins__content">{pin.content || ''}</div>
                </div>
                {canUnpin && (
                  <button
                    type="button"
                    className="community-pins__unpin"
                    onClick={() => onUnpin(pin.messageId)}
                    aria-label="Unpin message"
                    title="Unpin"
                  >
                    ×
                  </button>
                )}
              </li>
            );
          })}
        </ul>
      )}
    </aside>
  );
}

function PinIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <line x1="12" y1="17" x2="12" y2="22" />
      <path d="M5 17h14l-3-5V6a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v6l-3 5z" />
    </svg>
  );
}

function formatTimestamp(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return `${d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })}, ${d.toLocaleDateString()}`;
}

PinnedMessagesPopover.propTypes = {
  pinned: PropTypes.array.isRequired,
  loading: PropTypes.bool,
  canUnpin: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onUnpin: PropTypes.func.isRequired,
};

export default PinnedMessagesPopover;
